import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
  *,
  *::before,
  *::after{box-sizing:border-box;}
  a{text-decoration:none; color:inherit; cursor:pointer;}
  button{background-color:transparent; color:inherit; border-width:0; padding:0; cursor:pointer;}
  figure{margin:0;}
  input::-moz-focus-inner {border:0; padding:0; margin:0;}
  ul, ol, dd{margin:0; padding:0; list-style:none;}
  h1, h2, h3, h4, h5, h6{margin:0; font-size:inherit; font-weight:inherit;}
  p{margin:0;}
  cite {font-style:normal;}
  fieldset{border-width:0; padding:0; margin:0;}
  body, html {
    margin: 0;
    padding: 0;
  }

  input {
    /* -webkit-appearance: none; */
  }

  body {
    /** For iPhone X > */
    padding-left: constant(safe-area-inset-left);
    padding-right: constant(safe-area-inset-right);
  }

  :root {
    --reach-dialog: 1;
    --reach-menu-button: 1;
    --reach-listbox: 1;
    --reach-tabs: 1;
  }

  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: transparent;
  }

  #__next {
    position: relative;
  }
  
  /* Used to detect in JavaScript if apps have loaded styles or not. */
  :root {
    --reach-dialog: 1;
  }

  [data-reach-dialog-overlay] {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index:99;
  }

  [data-reach-dialog-content] {
    overflow: auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: hsla(0, 0%, 0%, 0.33);
    display: flex;
    align-items: flex-start;
  }
`
